import { QueryClient } from "@tanstack/react-query";
import { LoaderFunctionArgs } from "react-router";
import { PARTNERS_QUERIES } from "~/shared/api/partners/partners.queries";
import { notFound } from "~/shared/util/notFound";

export function editPartnerContactViewLoader({ params }: LoaderFunctionArgs, queryClient: QueryClient) {
  const { partnerId, contactId } = params;

  if (!partnerId || !contactId) {
    return notFound();
  }

  queryClient.prefetchQuery(PARTNERS_QUERIES.recruiterDetail(parseInt(partnerId, 10), parseInt(contactId, 10)));
}
